import { useParams } from "react-router-dom";

import PanelsLayout from "components/PanelsLayout";
import EmptyPanel from "components/EmptyPanel";

import ArchiveView from "./ArchiveView";
import ConductView from "./ConductView";
import CouncilorsView from "./CouncilorsView";
import PortalSettingsView from "./PortalSettingsView";
import SessionView from "./SessionView";
import styles from "./styles.module.scss";

// Biuro rady — port modułu CouncilSessionAgenda z Magistratu.
//
// Widoki pod jedną pozycją menu:
//   /biuro-rady/sesja    → „Sesja" (SessionList): wybór sesji bieżącej + porządek obrad,
//   /biuro-rady/archiwum → „Archiwum sesji" (ArchiveControl): kalendarz roczny sesji,
//   /biuro-rady/obrady   → „Prowadzenie obrad": stan sesji, obecność, głosowania,
//   /biuro-rady/radni    → „Radni" (CouncilorsList): konta portalu radnego,
//   /biuro-rady/portal   → „Portal radnego": adres portalu i zasady głosowań.
//
// Etap 1 to przygotowanie porządku obrad z załącznikami (pliki nieszyfrowane — trafiają
// na publiczny portal). Etap 2 (te trzy ostatnie widoki + osobna aplikacja portalu)
// dokłada radnych, prowadzenie obrad i głosowania.

const VIEWS: Record<string, { title: string; element: JSX.Element }> = {
  archiwum: { title: "Archiwum sesji", element: <ArchiveView /> },
  obrady: { title: "Prowadzenie obrad", element: <ConductView /> },
  radni: { title: "Radni", element: <CouncilorsView /> },
  portal: { title: "Portal radnego", element: <PortalSettingsView /> },
};

const CouncilModule = () => {
  const { view } = useParams();

  // Wyliczane z trasy, a nie trzymane w stanie — przy przejściu między widokami
  // React zachowuje ten sam komponent i inicjalizator useState by się nie powtórzył.
  const current = (view && VIEWS[view]) ?? {
    title: "Sesja",
    element: <SessionView />,
  };

  return (
    <PanelsLayout
      title="Biuro rady"
      subTitle={current.title}
      disableSearch
      leftClassName={styles.leftPanel}
      leftPanel={<div className={styles.panel}>{current.element}</div>}
      hideRight
      rightPanel={<EmptyPanel />}
    />
  );
};

export default CouncilModule;
